import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sports',
  templateUrl: './sports.component.html',
  styleUrls: ['./sports.component.scss']
})
export class SportsComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  btnBackClick = function () {
    this.router.navigateByUrl('/conditions');
  }
}
